import { Routes } from '@angular/router';
import { HomeLayout } from './layouts/home-layout/home-layout';
import { AdminLayout } from './layouts/admin-layout/admin-layout';
import { Home } from './pages/home/home';
import { AboutUs } from './pages/about-us/about-us';
import { ServicesPage } from './pages/services/services';
import { ServiceDetail } from './pages/service-detail/service-detail';
import { LoginComponent } from './pages/login/login';
import { ForgotPassword } from './pages/forgot-password/forgot-password';
import { ResetPassword } from './pages/reset-password/reset-password';
import { Dashboard } from './pages/admin/dashboard/dashboard';
import { Services } from './pages/admin/services/services';
import { AddService } from './pages/admin/add-service/add-service';
import { Posts } from './pages/posts/posts';
import { PostDetail } from './pages/post-detail/post-detail';
import { ManagePosts } from './pages/admin/manage-posts/manage-posts';
import { PostEditor } from './pages/admin/post-editor/post-editor';
import { PostCategories } from './pages/admin/post-categories/post-categories';
import { ServiceCategories } from './pages/admin/service-categories/service-categories';
import { Staff } from './pages/admin/staff/staff';
import { Customers } from './pages/admin/customers/customers';
import { Appointments } from './pages/admin/appointments/appointments';
import { Testimonials } from './pages/admin/testimonials/testimonials';
import { Leaves } from './pages/admin/leaves/leaves';
import { SiteSettings } from './pages/admin/site-settings/site-settings';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin-guard';

export const routes: Routes = [
	{
		path: '',
		component: HomeLayout,
		children: [
			{
				path: '',
				component: Home,
				title: 'The OG Studio - Premium Hair Restoration & Transplant Services in Hyderabad',
				data: {
					meta: {
						description: 'Experience the best in hair restoration and transplant services at The OG Studio in Hyderabad. Our expert team offers personalized solutions to help you regain your confidence with natural-looking results.',
						keywords: 'hair restoration, hair transplant, Hyderabad, The OG Studio, natural-looking results, personalized solutions',
					}
				}
			},
			{
				path: 'about',
				component: AboutUs,
				title: 'About Us - The OG Studio',
				data: {
					meta: {
						description: 'Learn more about The OG Studio, a leading hair restoration and transplant clinic in Hyderabad. Our expert team is dedicated to providing personalized solutions for natural-looking results.',
						keywords: 'hair restoration, hair transplant, Hyderabad, The OG Studio, personalized solutions, natural-looking results',
					}
				}
			},
			{
				path: 'services',
				component: ServicesPage,
				title: 'Our Services - The OG Studio',
				data: {
					meta: {
						description: 'Discover the range of hair restoration and transplant services offered at The OG Studio in Hyderabad. Our expert team provides personalized solutions for natural-looking results.',
						keywords: 'hair restoration, hair transplant, Hyderabad, The OG Studio, personalized solutions, natural-looking results',
					}
				}
			},
			{
				path: 'services/:slug',
				component: ServiceDetail,
			},
			{
				path: 'blog',
				component: Posts,
				title: 'Blog - The OG Studio',
				data: {
					meta: {
						description: 'Read the latest articles and insights on hair restoration and transplant services at The OG Studio in Hyderabad. Stay informed with expert advice and tips for maintaining healthy hair.',
						keywords: 'hair restoration, hair transplant, Hyderabad, The OG Studio, blog, expert advice, healthy hair tips',
					}
				}
			},
			{
				path: 'blog/:slug',
				component: PostDetail,
			},
		],
	},
	{
		path: 'login',
		component: LoginComponent,
	},
	{
		path: 'forgot-password',
		component: ForgotPassword,
	},
	{
		path: 'reset-password',
		component: ResetPassword,
	},
	{
		path: 'admin',
		component: AdminLayout,
		canActivate: [authGuard, adminGuard],
		children: [
			{
				path: '',
				redirectTo: 'dashboard',
				pathMatch: 'full',
			},
			{
				path: 'dashboard',
				component: Dashboard,
			},
			{
				path: 'services',
				component: Services,
			},
			{
				path: 'services/add',
				component: AddService,
			},
			{
				path: 'services/edit/:id',
				component: AddService,
			},
			{
				path: 'service-categories',
				component: ServiceCategories,
			},
			{
				path: 'staff',
				component: Staff,
			},
			{
				path: 'customers',
				component: Customers,
			},
			{
				path: 'appointments',
				component: Appointments,
			},
			{
				path: 'testimonials',
				component: Testimonials,
			},
			{
				path: 'leaves',
				component: Leaves,
			},
			{
				path: 'blog',
				component: ManagePosts,
			},
			{
				path: 'blog/add',
				component: PostEditor,
			},
			{
				path: 'blog/edit/:id',
				component: PostEditor,
			},
			{
				path: 'post-categories',
				component: PostCategories,
			},
			{
				path: 'site-settings',
				component: SiteSettings,
			},
		],
	},
];
